import React from 'react';

const TextArea = ({ label, inputHandler, value, row, col }) => {
  const dataHandler = (event) => {
    inputHandler(event.target.value);
  };

  return (
    <div className='form-container'>
      <div className='form__field'>
        <label className='form__field-label capitalize' htmlFor='message'>
          {label}
        </label>
        <textarea
          className='form__field-textarea'
          id={label}
          name={label}
          rows={row}
          cols={col}
          value={value}
          onChange={dataHandler}
        ></textarea>
      </div>
    </div>
  );
};

export default TextArea;
